import React from "react";
import "../PlanManagements/PlanManagements.scss";
import TableForPlan from "../TableForPlan/TableForPlan";

const PlanManagements = () => {
  return (
    <>
    <div className='admin-content-wrapper'>
      <div className="admin-content-subheader">
        <div className="admin-content-subheader-title">Plan Management</div>
      </div>

      <TableForPlan />
    </div>
    </>
  );
};

export default PlanManagements;
